import {useCallback, useState} from 'react';
import {hasCookie, useInterval} from '@aboutyou/utils';

export const useIsConsentBannerClosed = (intervalTime = 500) => {
  const [isConsentBannerClosed, setIsConsentBannerClosed] = useState(
    isConsentClosedCookie(),
  );

  useInterval(
    useCallback(() => {
      if (isConsentClosedCookie()) {
        setIsConsentBannerClosed(true);
      }
    }, []),
    isConsentBannerClosed ? null : intervalTime,
  );

  return isConsentBannerClosed;
};

const isConsentClosedCookie = () =>
  typeof document !== 'undefined' &&
  hasCookie('OptanonAlertBoxClosed=', document?.cookie || '');
